<template>
<div class="MyTicketPage">
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12 p-10">
          <qr-code text="Text to encode"></qr-code>
        </v-card>
      </v-flex>
    </v-layout>
</div>
</template>

<script>
import Vue from 'vue'
import VueQRCodeComponent from 'vue-qrcode-component'
Vue.component('qr-code', VueQRCodeComponent)
  export default {
    name: 'ServicesPage',
    data() {
      return {
        
      }
    },
    mounted() {
    
    },
    created() {
      return {}
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.v-card {
margin: 10px;
border: 15px solid white;
}
</style>
